import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExposeService } from '../services/expose-service';
import { SpinnerService } from 'src/app/all-modules/shared/services/spinner.service';
import { ApiResponse } from 'src/app/all-modules/shared/common-model/common.model';

/**
 * Public /s/:key page — our own SMS short links, replacing Bitly. Looks the key up and opens the
 * page it points to (today: a client's gallery link), replacing /s/ in history so Back does not
 * land here again. Only CLIENT texts use these; internal texts keep the direct /gallery/ URL
 * because the LeadMan app claims only /gallery/ paths.
 */
@Component({
  selector: 'app-short-link-redirect',
  templateUrl: './short-link-redirect.component.html',
  styleUrl: './short-link-redirect.component.scss',
  standalone: false
})
export class ShortLinkRedirectComponent implements OnInit {
  loading = true;
  notFound = false;
  loadError = false;

  constructor(private route: ActivatedRoute, private router: Router, private exposeService: ExposeService,
    private spinner: SpinnerService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    const key = this.route.snapshot.paramMap.get('key') || '';
    this.spinner.show();
    this.exposeService.resolveShortLink(key).subscribe({
      next: (res: ApiResponse) => {
        this.spinner.hide();
        const target = res?.success ? res.data : null;
        if (this.isAppPath(target)) {
          this.router.navigateByUrl(target, { replaceUrl: true });
          return;
        }
        this.loading = false;
        this.notFound = true;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.spinner.hide();
        this.loading = false;
        this.loadError = true;
        console.error('[ShortLink] failed to resolve link', err);
        this.cdr.detectChanges();
      }
    });
  }

  // The API only stores app-relative paths; checked again here so a bad value can never send
  // the visitor anywhere but a page of this app.
  private isAppPath(target: unknown): target is string {
    return typeof target === 'string' && target.startsWith('/') && !target.startsWith('//') && !target.startsWith('/\\');
  }
}
